import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ThanksDialogueComponent } from '../thanks-dialogue/thanks-dialogue.component';
import { MyJsonLdComponent } from './my-json-ld.component';
import { SocialAuthService } from 'angularx-social-login';
import { WhyIquantaBestComponent } from './why-iquanta-best/why-iquanta-best.component';
import { CourseComparisonHomeComponent } from './course-comparison-home/course-comparison-home.component'
import { NewFooterComponent } from './new-footer/new-footer.component';
import { FaqsNewComponent } from './faqs-new/faqs-new.component';
import { ColorSplashComponent, TopBarComponent } from '../top-bar/top-bar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { PipeModule } from '../pages/pipe.module'
import { ConfirmationComponent } from '../confirmation/confirmation.component';
import { MatButtonModule } from '@angular/material/button';
import { ToppersMeetComponent } from './toppers-meet/toppers-meet.component';
import { MatDialogModule } from '@angular/material/dialog';
import { CourseCardHomeComponent } from './course-card-home/course-card-home.component'
import { IquantaFeaturesComponent } from './iquanta-features/iquanta-features.component';
import { StudentCarouselComponent } from './student-carousel/student-carousel.component';
import { FounderHomeComponent } from './founder-home/founder-home.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { LoginModal } from '../header/header.component'
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input'
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { CourseExtrasBottomSheet, CourseModuleComponent, FormDialog, ProductCouponDialogNew } from './course-module/course-module.component'
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { CatCoursePackageMocksComponent, LeadFormDialog, TargetSetDialog } from './cat-course-package/cat-course-package-mocks.component'
import { TooltipModule } from 'ng2-tooltip-directive';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ConstantService } from 'src/providers/constants';
import { BSchoolService } from 'src/providers/b-schools.service';
import { JSONIDService } from 'src/providers/schema'
import { CompassComponent } from '../compass/compass.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    PipeModule,
    MatButtonModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    NgxSpinnerModule,
    MatCheckboxModule,
    MatCardModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatSnackBarModule,
    MatSelectModule,
    MatBottomSheetModule,
    NgxSliderModule,
    TooltipModule,
    MatTooltipModule
  ],

  declarations: [
    StudentCarouselComponent,
    FounderHomeComponent,
    LoginModal,
    ThanksDialogueComponent,
    MyJsonLdComponent,
    WhyIquantaBestComponent,
    CourseComparisonHomeComponent,
    NewFooterComponent,
    FaqsNewComponent,
    TopBarComponent,
    CompassComponent,
    ConfirmationComponent,
    ToppersMeetComponent,
    CourseCardHomeComponent,
    IquantaFeaturesComponent,
    ColorSplashComponent,
    CourseModuleComponent,
    ProductCouponDialogNew,
    FormDialog,
    CourseExtrasBottomSheet,
    CatCoursePackageMocksComponent,
    LeadFormDialog,
    TargetSetDialog

  ],

  exports: [
    StudentCarouselComponent,
    FounderHomeComponent,
    LoginModal,
    ThanksDialogueComponent,
    MyJsonLdComponent,
    WhyIquantaBestComponent,
    CourseComparisonHomeComponent,
    NewFooterComponent,
    FaqsNewComponent,
    TopBarComponent,
    CompassComponent,
    PipeModule,
    ConfirmationComponent,
    ToppersMeetComponent,
    CourseCardHomeComponent,
    IquantaFeaturesComponent,
    ColorSplashComponent,
    CourseModuleComponent,
    ProductCouponDialogNew,
    FormDialog,
    CourseExtrasBottomSheet,
    CatCoursePackageMocksComponent,
    LeadFormDialog,
    TargetSetDialog
  ],
  providers: [
    SocialAuthService,
    DatePipe,
    ConstantService,
    BSchoolService, JSONIDService,
  ]

})
export class ChildComponentsModule { }
